import type { InsertBlockPluginOptions } from '@atlaskit/editor-plugin-insert-block';

interface Props {
	options: Pick<InsertBlockPluginOptions, 'tableSelectorSupported' | 'appearance'>;
}

export function insertBlockPluginOptions({ options }: Props): InsertBlockPluginOptions {
	return {
		allowTables: true,
		allowExpand: true,
		horizontalRuleEnabled: true,
		tableSelectorSupported: options.tableSelectorSupported,
		nativeStatusSupported: true,
		showElementBrowserLink: true,
		appearance: options.appearance,
	};
}
